(function(){
  var toggle=document.querySelector('[data-menu-toggle]'),header=document.querySelector('[data-header]');
  if(toggle&&header){toggle.addEventListener('click',function(){var o=header.classList.toggle('is-open');toggle.setAttribute('aria-expanded',o);});}
  // galeria
  var thumbs=document.querySelectorAll('[data-thumb]');
  function showMedia(id){
    document.querySelectorAll('[data-media]').forEach(function(m){m.classList.toggle('is-active',m.getAttribute('data-media')===String(id));});
    thumbs.forEach(function(t){t.classList.toggle('is-active',t.getAttribute('data-thumb')===String(id));});
  }
  thumbs.forEach(function(t){t.addEventListener('click',function(){showMedia(t.getAttribute('data-thumb'));});});
  // variantes
  var form=document.querySelector('[data-product-form]'),jsonEl=document.querySelector('[data-product-json]');
  if(form&&jsonEl){
    var product=JSON.parse(jsonEl.textContent),cur=form.getAttribute('data-currency')||'BRL';
    var idInput=form.querySelector('[name=id]'),btn=form.querySelector('[data-add]'),priceEl=document.querySelector('[data-price]');
    var money=function(c){return (c/100).toLocaleString('pt-BR',{style:'currency',currency:cur});};
    var update=function(){
      var sel=[];form.querySelectorAll('[data-option]').forEach(function(g){var c=g.querySelector('input:checked');sel.push(c?c.value:null);});
      var v=product.variants.find(function(x){return x.options.every(function(o,i){return o===sel[i];});});
      if(!v){btn.disabled=true;btn.textContent='Combinação indisponível';return;}
      idInput.value=v.id;btn.disabled=!v.available;btn.textContent=v.available?'Adicionar à sacola':'Esgotado';
      var html=v.compare_at_price&&v.compare_at_price>v.price?'<span class="sale">'+money(v.price)+'</span><s>'+money(v.compare_at_price)+'</s>':money(v.price);
      if(priceEl)priceEl.innerHTML=html;
      if(window.history&&history.replaceState)history.replaceState(null,'','?variant='+v.id);
      if(v.featured_media)showMedia(v.featured_media.id);
    };
    form.addEventListener('change',update);
  }

  var root=document.documentElement,reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // modo claro/noite
  var tts=document.querySelectorAll('[data-theme-toggle]');
  var syncT=function(){var d=root.getAttribute('data-theme')==='dark';tts.forEach(function(b){b.setAttribute('aria-pressed',d);});};
  syncT();
  tts.forEach(function(b){b.addEventListener('click',function(){
    var d=root.getAttribute('data-theme')!=='dark';
    if(d){root.setAttribute('data-theme','dark');document.body.style.removeProperty('--page-bg');}else{root.removeAttribute('data-theme');}
    try{localStorage.setItem('wan-theme',d?'dark':'light');}catch(e){}
    syncT();
  });});
  // fundo que muda suavemente conforme a rolagem
  var secs=document.querySelectorAll('[data-scroll-bg]');
  if(secs.length&&'IntersectionObserver' in window&&!reduce){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting&&root.getAttribute('data-theme')!=='dark'){document.body.style.setProperty('--page-bg',e.target.getAttribute('data-scroll-bg'));}
    });},{rootMargin:'-45% 0px -45% 0px'});
    secs.forEach(function(s){io.observe(s);});
  }
  // título do banner que muda de escala na rolagem
  var kt=document.querySelector('[data-kinetic]');
  if(kt&&!reduce){
    var tick=false;
    window.addEventListener('scroll',function(){
      if(tick)return;tick=true;
      requestAnimationFrame(function(){(kt.closest('.hero')||kt).style.setProperty('--k',Math.min(window.scrollY/500,1).toFixed(3));tick=false;});
    },{passive:true});
  }

  // elementos que surgem suavemente ao rolar
  var items=document.querySelectorAll('.section__head,.cat,.card,.benefit,.quote,.promo__grid>*,.news .wrap>*');
  if('IntersectionObserver' in window&&!reduce){
    var ro=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');ro.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.08});
    items.forEach(function(el){
      var sib=Array.prototype.indexOf.call(el.parentNode.children,el);
      el.style.setProperty('--d',((sib%4)*0.09).toFixed(2)+'s');
      el.setAttribute('data-reveal','');
      ro.observe(el);
    });
  }
})();
